// src/rms/utils/assetLabel.js
// ============================================================================
// Naming an asset
// ============================================================================
// Operators run their yard by the code, not the name. Two boats can both be
// "Catalina 22"; only one is BOA-004. Two storage units can both be "10x10";
// only one is B12.
//
// Every trade has its own word for that code — Unit #, Vessel #, Machine #,
// Garment #, Asset tag — so the LABEL comes from the vertical preset
// (terminology.assetCode). Only the formatting lives here.
//
// This sits in utils rather than components because the invoice generator in
// data/rentalService.js needs it too, and the data layer must not import from
// the component layer.
// ============================================================================

/**
 * "BOA-004 — Windward". For titles, pickers and invoice line descriptions.
 *
 * Falls back to the name alone rather than printing a dangling separator, so a
 * record imported without a code still reads correctly.
 */
export function assetLabel(asset, fallback = "—") {
  if (!asset) return fallback;
  const name = asset.name || fallback;
  return asset.asset_code ? `${asset.asset_code} — ${name}` : name;
}

export default assetLabel;
